<template>
    <v-container
            class="loginBackground"
            heigth="100%"
            justify="center" align="center"
    >
        <v-row justify="center" align="center" heigth="100%">
            <v-col>
                <v-form ref="form" v-model="valid" lazy-validation class="position-relative formLogin">
                    <v-card min-height="395" width="'100%'">
                        <v-container>
                            <v-row justify="start" align="center">
                                <v-col cols="12" justify="center" align="center" class="pt-0 pb-0">
                                    <v-img width="200" src='../images/logodesk.png' alt="Logo Omega"
                                           class="loginLogo"></v-img>
                                </v-col>
                                <v-col cols="12" justify="center" align="center" class="pt-0 pb-0">
                                    <h3>ברוכים הבאים
                                        <br>
                                        לאפליקציית משלוחים אומגה</h3>
                                </v-col>
                            </v-row>
                            <v-row justify="start" align="start">
                                <v-col cols="12" align-self="start" class="pt-0 pb-0 mt-0 px-6">
                                    <v-text-field
                                            class="pt-0 pb-0"
                                            :rules="[rules.nameRequired]"
                                            v-model="username" label="שם משתמש" required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" align-self="start" class="pt-0 pb-0 px-6">
                                    <v-text-field
                                            class="pt-0 pb-0"
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show1 ? 'text' : 'password'"
                                            @click:append="show1 = !show1"
                                            :rules="[rules.passRequired]"
                                            v-model="password" label="סיסמה" required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                    <v-btn
                            class="doLogin white--text"
                            :color="'#0c1c62'"
                            bottom
                            absolute
                            block
                            tile
                            right
                            large
                            height="60"
                            @click="doLogin"
                    >
                        כניסה
                    </v-btn>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {HTTP} from '../http/http-common.js';
    import router from '../router';
    export default {
        name: "vLogin",
        data: () => {
            return {
                valid: true,
                show1: false,
                loginError: false,
                username: '',
                password: '',
                rules: {
                    nameRequired: value => !!value || 'שדה שם משתמש הינו שדה חובה.',
                    passRequired: value => !!value || 'שדה סיסמה הינו שדה חובה.',
                },

            }
        },
        computed: {

        },
        methods: {
            doLogin: function() {
                let self = this;
                let data = {
                    username: this.username,
                    password: this.password,
                }
                HTTP.post('login', data).then(function (resp) {
                    if(resp && resp.token) {
                        window.localStorage.setItem('token', resp.token);
                        window.localStorage.setItem('Name', resp.name);
                        window.localStorage.setItem('zoho_name', resp.zoho_name);
                        window.localStorage.setItem('role', resp.role);
                        //state.userName = resp.name
                        router.push('/')
                    }
                })
                .catch(function (resp) {
                    let data = {
                        text: 'שגיאה בתחברות',
                        status: 'error'
                    }
                    //self.loginError = !self.loginError;
                    console.log(resp);
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .loginBackground {
        height: 100vh;
        width: 100vw;
        background-image: url('../../images/loginBG.png');
        background-size: cover;
        //background-repeat: no-repeat;
        display: flex;
    }

    .formLogin {
        min-height: 600px;
    }

    .loginLogo {
        margin-bottom: 30px;
    }

    .doLogin {
        bottom: 0 !important;
        right: 0 !important;
        font-size: 19px !important;
        font-weight: 500 !important;
        text-align: center;
        color: #ffffff;
    }

    h3 {
        font-size: 22px;
        line-height: 1.18;
        text-align: center;
        margin-bottom: 40px;
        color: #000000;
        font-weight: normal;
    }
</style>
